<template>
  <div id="signupC" class="single-page-signup">
    <div v-if="isMobile">
      <hero-banner :id="'mobile'" />
      <div class="container">
        <div class="row mx-0">
          <div class="col-12 px-0">
            <coffee-preparation />
            <div class="single-page-signup-section-separator" />
            <choose-your-coffee />
            <div class="single-page-signup-section-separator" />
            <bag-size />
            <div class="single-page-signup-section-separator" />
            <order-summary />
          </div>
        </div>
      </div>
      <pact-promise />
      <welcome-better-coffee />
      <order-summary-sticky-btn />
    </div>
    <div v-else class="container">
      <div class="row mx-0">
        <div class="col-12 px-0 col-lg-7 row mx-0">
          <div class="col-12 px-0">
            <hero-banner :id="'desktop'" />
          </div>
          <div class="col-12 px-4">
            <coffee-preparation />
            <div class="single-page-signup-section-separator" />
            <choose-your-coffee />
            <div class="single-page-signup-section-separator" />
            <bag-size />
          </div>
          <div class="col-12 px-0">
            <pact-promise />
            <welcome-better-coffee />
          </div>
        </div>
        <div class="col-12 px-0 col-lg-5 order-summary-column">
          <order-summary />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import HeroBanner from '../elements/HeroBanner.vue'
import CoffeePreparation from '../elements/CoffeePreparation.vue'
import ChooseYourCoffee from '../elements/ChooseYourCoffee.vue'
import BagSize from '../elements/BagSize.vue'
import OrderSummary from '../elements/OrderSummary.vue'
import OrderSummaryStickyBtn from '../elements/OrderSummaryStickyBtn.vue'
import PactPromise from '../elements/PactPromise.vue'
import WelcomeBetterCoffee from '../elements/WelcomeBetterCoffee.vue'
import { useMobileHelpers } from '../../utils/composables/mobileHelpers.js'

const { isMobile } = useMobileHelpers()
</script>

<script>
export default {
  name: 'SignupCPage',
}
</script>

<style lang="scss" scoped>
.single-page-signup {
  // padding-bottom: 50px;

  &-section-separator{
    border-bottom: 3px solid #F4F4F4;
    width: 100vw;
    left: -20px;
    position: relative;

    @media(min-width: 400px){
      left: -30px;
      width: calc(100% + 60px);
    }
  }
}

.order-summary-column {
  @media (min-width: 992px) {
    align-self: flex-start;
    position: sticky;
    top: 80px;
  }
}
</style>
